<script lang="ts" setup>
    const { handle, itemClass, linkClass, arrows } = defineProps<{
        handle: string
        itemClass?: string
        linkClass?: string
        arrows?: boolean
    }>()

    const { data: navItems } = await useStatamicNavs().getNavTree({ handle })
</script>

<template>
    <ul class="nav-display" :data-nav="handle">
        <li v-for="item in navItems" class="relative block" :class="itemClass">
            <NuxtLink
                :to="item.page.url"
                class="group flex items-end justify-between hover:text-medium"
                :class="{ [linkClass]: true }"
                @click="useNavOpen().value = false"
            >
                <span class="transition">{{ item.page.title }}</span>

                <Arrow
                    v-if="arrows"
                    class="relative right-0 top-[-0.05em] group-hover:right-[-0.1em] group-hover:top-[-0.15em]"
                />
            </NuxtLink>
        </li>
    </ul>
</template>

<style>
    .nav-is-open {
        .quote-link,
        [data-nav='top'] {
            pointer-events: none;

            span,
            a:after {
                opacity: 0;
            }
        }

        .quote-link {
            opacity: 0;
        }
    }
</style>
